import { useState, useEffect } from "react";
import type { TemporaryProject } from "../screens/landing/tabs/dashboard/ProjectWatchList/temporaryProjectManager";
import { temporaryProjectManager } from "../screens/landing/tabs/dashboard/ProjectWatchList/temporaryProjectManager";
import type { Collection } from "types/collection";

export function useTemporaryProjects(collections?: Collection[]) {
  const [temporaryProjects, setTemporaryProjects] = useState<TemporaryProject[]>([]);
  const [tickerToLogoMap, setTickerToLogoMap] = useState<Record<string, string>>({});

  // Subscribe to changes
  useEffect(() => {
    const unsubscribe = temporaryProjectManager.subscribe((projects) => {
      setTemporaryProjects(projects);
    });
    setTemporaryProjects(temporaryProjectManager.getTemporaryProjects());
    return unsubscribe;
  }, []);

  useEffect(() => {
    temporaryProjects.forEach((project) => {
      if (project.companyLogoUrl) {
        setTickerToLogoMap((prev) => ({
          ...prev,
          [project.ticker.toLowerCase()]: project.companyLogoUrl as string,
        }));
      }
    });
  }, [temporaryProjects]);

  // Check for completed projects if collections are provided
  useEffect(() => {
    if (!collections) return;

    temporaryProjects.forEach((tempProject) => {
      const matchingCollections = collections.filter((collection) => collection.ticker?.toLowerCase() === tempProject.ticker.toLowerCase());

      const hasCompleteProject = matchingCollections.some(
        (collection) => collection.name && collection.metadata && collection.metadata.createdTime && collection.id && collection.workflowIds
      );

      if (hasCompleteProject) {
        temporaryProjectManager.removeTemporaryProject(tempProject.id);
      } else {
        const timeElapsed = Date.now() - tempProject.createdAt;
        const TIME_LIMIT = 60000;
        if (timeElapsed > TIME_LIMIT) {
          temporaryProjectManager.removeTemporaryProject(tempProject.id);
        }
      }
    });
  }, [collections, temporaryProjects]);

  return { temporaryProjects, tickerToLogoMap };
}
